module.exports = __webpack_public_path__ + "img/bg2.ae692a66.png";